import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ChevronRight = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 6 10"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path d="M1 1L5 5L0.999999 9" stroke="currentColor" strokeLinecap="round" />
  </SvgIcon>
);
